import React, { useEffect } from 'react';
import moment from 'moment';
import { IDateRange, IOption } from  '@/interfaces/insightsp2';
import { Truncate } from  '@/helpers/Text';
import { buildCustomDate } from  '@/helpers/Dates';

type Props = {
    selectedOptions:IOption[], 
    label?:string,
    customDate?:Date[],
    selectedDates?:IDateRange,
    placeholder?:string,
    showDateLabel:boolean
}

const SelectLabel = ({selectedOptions, label, placeholder, customDate, showDateLabel, selectedDates }: Props) => {

    function dateLabel(){

        //console.log({selectedOptions, label, placeholder, customDate, showDateLabel, selectedDates })  

        if (!showDateLabel){
            return null
        }
        
        // Hide for custom date not yet selected
        if (selectedOptions && selectedOptions[0].value === "custom" && !customDate){ 
            return null
        }

        // Pre-selected range
        if (selectedDates && !customDate){

            // Single day
            if (selectedDates.dateFrom.setHours(0,0,0,0) === selectedDates.dateTo.setHours(0,0,0,0)){
                return (
                    <span>
                        &nbsp;({buildCustomDate(selectedDates.dateFrom)})
                    </span>
                )
            }

            // Lifetime
            if (label === "Lifetime"){
                return (
                    <span className="date-label">
                        (up to - {buildCustomDate(selectedDates.dateTo)})
                    </span>
                )
            }

            return (
                <span className="date-label">
                    ({buildCustomDate(selectedDates.dateFrom)} - {buildCustomDate(selectedDates.dateTo)})
                </span>
            )
        }

        // Custom range
        if (customDate && customDate.length){
            console.log(customDate)
            // Single day            
            if (customDate.length === 2 && customDate[0].setHours(0,0,0,0) === customDate[1]?.setHours(0,0,0,0)){
                return (
                    <span>
                        &nbsp;- {buildCustomDate(customDate[0])}
                    </span>
                )
            }

            return (
                <span className="date-label">
                    ({buildCustomDate(customDate[0])} - {buildCustomDate(customDate[1])})
                </span>
            )
        }
        
        return null
    }

    // Single selection
    if (selectedOptions.length === 1){
        return (
            <>
                {Truncate(selectedOptions[0].label, 15)}{dateLabel()}
            </>
        )
    }

    // Multi select
    if (selectedOptions.length > 1){
        return (
            <>
                {Truncate(selectedOptions[0].label,15)} +{selectedOptions.length -1}
            </>
        )
    }

    // Label selected
    if (label && label !== ""){
        return (
            <>
                {label} 
            </>
        )
    }

    // Default
    return (
        <>
            {placeholder ? placeholder : "All..."}
        </>
    )
}

export default SelectLabel;